"use client";

export default function PageIndexPage() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50vh",
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <div>
        <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
          Page Directory
        </h1>
        <p style={{ color: "#666" }}>Coming Soon</p>
      </div>
    </div>
  );
}
